export const strings = {
    prefixAgo: null,
    prefixFromNow: null,
    suffixAgo: '',
    suffixFromNow: '',
    seconds: 's',
    minute: '1m',
    minutes: '%dm',
    hour: '1h',
    hours: '%dh',
    day: '1T.',
    days: '%dT.',
    month: '1Mt.',
    months: '%dMt.',
    year: '1J.',
    years: '%dJ.',
    wordSeparator: ' ',
};
